import { useRef, useState } from "react";
import Text from "../shared-components/Text";
import FormActionButton from "../shared-components/FormActionButton";
import { formPages } from "../../constants";
import EmailInput from "../shared-components/EmailInput";
import { isValidEmail, isValidMobile } from "../../utils/utils";
import "../form-pages/AddressDetails.css";
import "../form-pages/ContactDetails.css";
import MobileModal from "../shared-components/MobileModal";

export default function ContactDetails({
  compensate,
  onNext,
  onBack,
  isSubmitted,
}) {
  const [email, setEmail] = useState(compensate.email ?? "");
  const [confirmEmail, setConfirmEmail] = useState(
    compensate.confirmEmail ?? "",
  );
  const [mobile, setMobile] = useState(
    compensate.mobile && isValidMobile(compensate.mobile)
      ? compensate.mobile
      : "",
  );

  const [emailAddressError, setEmailAddressError] = useState(false);
  const [confirmEmailError, setConfirmEmailError] = useState(false);
  const [emailValidationError] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const myRef = useRef(null);

  //const executeScroll = () => myRef.current.scrollIntoView()

  // Function to check if all mandatory fields are filled
  const isFormValid = () => {
    return isValidEmail(email);
  };

  /*const validateEmail = async() => {
    isSubmitted(true)
    try {
      const checkValidaty = await VALIDATE_EMAIL(email)
      if(checkValidaty){
        setEmailValidationError(false)
        onNext({
          email,
          mobile
        },(formPages.RegistrationDetails))
      }else{
        setEmailValidationError(true)
        executeScroll()
      }
      isSubmitted(false)
    } catch (error) {
      setEmailValidationError(true)
      executeScroll()
      console.error('Error validating email', error)
      isSubmitted(false)
    }
  }*/

  return (
    <>
      {showModal && (
        <MobileModal
          onClose={() => setShowModal(false)}
          onContinue={() => {
            setShowModal(false);
            onNext(
              { email, confirmEmail, mobile: "" },
              formPages.AddressDetails,
            );
          }}
        />
      )}

      <div
        className="d-flex malign-items-center heading-icon fdc-form row"
        ref={myRef}
        data-testid="page-contact"
        style={{ marginBottom: "0", paddingBottom: "0" }}
      >
        <h2 className="title" style={{ marginBottom: "0" }}>
          Let's keep you updated!
        </h2>
      </div>
      <div className="fdc-form gif-input" style={{ marginTop: "0" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="form-block">
              <EmailInput
                label={
                  "Please provide your email address so we can send you the details of your vehicle finance check."
                }
                placeholder={"example@gmail.com"}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (isValidEmail(e.target.value)) {
                    setEmailAddressError(false);
                  }
                }}
                value={email}
                id={"Email Address"}
                testId="contact-email"
              />
              {emailAddressError || emailValidationError ? (
                <div className="error-message">
                  <p>Please enter a valid email address</p>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-block">
              <EmailInput
                label={"Please re-enter your email address to confirm."}
                placeholder={"example@gmail.com"}
                onChange={(e) => {
                  setConfirmEmail(e.target.value);
                  if (e.target.value === email) {
                    setConfirmEmailError(false);
                  }
                }}
                onPaste={(e) => e.preventDefault()}
                value={confirmEmail}
                id={"Confirm Email Address"}
                testId="contact-confirm-email"
              />
              {confirmEmailError ? (
                <div className="error-message">
                  <p>Email addresses do not match</p>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-block">
              <Text
                className={"mb-0"}
                label={
                  "Please provide your mobile number to keep you updated at speed."
                }
                placeholder={"07"}
                onChange={(e) => {
                  let sanitizedValue = e.target.value.replace(/\D/g, "");
                  sanitizedValue = sanitizedValue.slice(0, 11);
                  setMobile(sanitizedValue);
                  setMobileNumberError(false);
                }}
                value={mobile}
                id={"Mobile Number"}
                testId="contact-mobile"
              />
              {mobileNumberError ? (
                <div className="error-message">
                  <p>
                    Please enter a valid mobile number, it must start with 07
                    and be 11 digits long.
                  </p>
                </div>
              ) : (
                <></>
              )}
              <p
                className="form-block"
                style={{
                  marginTop: "10px",
                  marginBottom: 0,
                  fontSize: "12px",
                }}
              >
                We will use this information to keep you updated on your claim.
              </p>
            </div>
          </div>
          <FormActionButton
            nextTestId="contact-btn-next"
            backTestId="contact-btn-back"
            onNext={() => {
              if (!isValidEmail(email) || email === undefined) {
                setEmailAddressError(true);
                return;
              }

              // Check if emails match
              if (email !== confirmEmail) {
                setConfirmEmailError(true);
                return;
              }

              // Validate mobile number if provided
              if (mobile && mobile.length > 0 && !isValidMobile(mobile)) {
                setMobileNumberError(true);
                return;
              }

              // Show modal if email is valid but mobile is empty
              if (isFormValid() && mobile === "") {
                setShowModal(true);
                return;
              }

              // Proceed if all validations pass
              if (isFormValid() && (mobile === "" || isValidMobile(mobile))) {
                onNext(
                  {
                    email,
                    confirmEmail,
                    mobile: mobile, // Always preserve the actual mobile value, including "07"
                  },
                  formPages.AddressDetails,
                );
              }
            }}
            onBack={() => {
              onBack(formPages.NewClaimantDetails, {
                // Preserve existing NewClaimantDetails data
                title: compensate.title,
                firstName: compensate.firstName,
                surname: compensate.surname,
                dob: compensate.dob,
                previousName: compensate.previousName,
                claims: compensate.claims || [],
                // Add current ContactDetails data
                email,
                confirmEmail,
                mobile: mobile,
              });
            }}
          />
        </div>
      </div>
    </>
  );
}
